/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("OurTeam", ["jquery", "Behaviors"], factory);
    } else {
        root.OurTeam = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    var moduleInstanceId;

    function OurTeam(target) {
       
        //handle multiple instances in one page

        this.moduleInstanceId = '.fl-node-' + target.getAttribute( 'data-OurTeam' );

        Behaviors.init(OurTeam, this, arguments);

        this.element = this.$elem[0];


    }

    Behaviors.inherit(OurTeam, Behaviors.Behavior);

    OurTeam.QUERY = "[data-OurTeam]";

    OurTeam.ELEMENTS = {
    };

    
    Behaviors.register_behavior(OurTeam);

    module.OurTeam = OurTeam;

    return module;
}));
